<div class="mat-subtitle-1">{{ title }}</div>
<div class="mat-subtitle-1">{{ subtitle }}</div>
<div
    ngfDrop
    class="file-upload-body"
    [selectable]="selectable"
    [multiple]="multipleFiles"
    [(files)]="files"
    (filesChange)="filesChange()"
    title="Add documentation. Drop/select a document"
    [matTooltip]="tooltipMessage"
    [fileDropDisabled]="isDisabled"
>
    @if (!validating && !loading) {
        <div class="row justify-content-center">
            <p class="col-12 fs-6 text-center">Drag and drop files here</p>
            <p class="col-12 tag-or text-center">or</p>
            <button mat-flat-button type="button" id="btn-uploader-file" class="text-uppercase col-12 col-md-6">
                Upload files
            </button>
        </div>
    }
    @if (validating || loading) {
        <div class="d-flex justify-content-center">
            <mat-spinner diameter="24" />
        </div>
    }
</div>
